import getSignedUrl from './getSignedUrl';

export const generateSignedImagesUrls = async <
  T extends Record<string, string>,
>(
  images: T,
): Promise<{ [K in keyof T]: string }> => {
  const result = {} as { [K in keyof T]: string };

  for (const key in images) {
    result[key] = await getSignedUrl(images[key]);
  }

  return result;
};

export const generateSignedImagesTabUrls = async <
  T extends Record<string, { path: string; height?: number; width?: number }>,
>(
  images: T,
): Promise<{ [K in keyof Record<string, string>]: string }> => {
  const result = {} as { [K in keyof T]: string };

  for (const key in images) {
    result[key] = await getSignedUrl(
      images[key].path,
      !!images[key].width ? images[key].width * 4 : undefined,
      images[key].height ? images[key].height * 4 : undefined,
    );
  }
  return result;
};
